import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService, ExportTaskProcessor } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { BusinessPartnerNewsService } from '../business-partner-news.service';
import { BUSINESS_PARTNER_NEWS_EXPORT_ID, BUSINESS_PARTNER_NEWS_TITLE, LOCALIZED_PROPERTIES } from './business-partner-news.constants';

@Injectable()
export class BusinessPartnerNewsExport {
  constructor(
    private exportService: ExportService,
    private  businessNewsService: BusinessPartnerNewsService,
  ) {}

  private transformItem(item: BusinessPartnerAttributes) {
    return {
      name: get(item, 'name', '??'),
      emails: get(item, 'emails.email', '??'),
      routes: `${get(item, 'routes.externalKeys.code', '??')}-${get(item, 'routes.name', '??')}`,
      addresses: get(item, 'addresses.geolocationPoint', '??'),
      createdAt: ExportTaskProcessor.types.excel.datetime(get(item, 'createdAt', null)),
      status: this.getStatus(get(item, 'statusId', '')),
    };
  }

  private getStatus(value: string | number): string {
    if(!value && value !== 0) {
        return '';
    }
    return value === 1 ? 'Activo' : 'Inactivo';
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: BUSINESS_PARTNER_NEWS_EXPORT_ID,
      title: BUSINESS_PARTNER_NEWS_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(BUSINESS_PARTNER_NEWS_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.businessNewsService.findByFilter(buildQuery(
          seed(this.businessNewsService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(BUSINESS_PARTNER_NEWS_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(BUSINESS_PARTNER_NEWS_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
